import { apiClient } from './client'
import { API_ENDPOINTS } from '@/utils/constants'

export interface PaymentUser {
  id: number
  email: string
  first_name?: string
  surname?: string
}

export interface PaymentPlan {
  id: number
  name: string
  slug: string
}

export interface Payment {
  id: number
  user_id: number
  subscription_plan_id: number
  amount: string
  status: string
  proof_file?: string
  user?: PaymentUser
  plan?: PaymentPlan
  created_at: string
  updated_at: string
}

interface PaymentsPaginator {
  data: Payment[]
  current_page: number
  last_page: number
  per_page: number
  total: number
}

interface PaymentsResponse {
  success: boolean
  data: PaymentsPaginator
}

export const paymentsApi = {
  getList: async (params?: { page?: number; perPage?: number }): Promise<{ data: Payment[]; total: number; currentPage: number; lastPage: number; perPage: number }> => {
    const response = await apiClient.get<PaymentsResponse>(API_ENDPOINTS.PAYMENTS, {
      params: { page: params?.page ?? 1, per_page: params?.perPage ?? 20 },
    })
    const paginator = response.data.data as PaymentsPaginator
    const list = Array.isArray(paginator?.data) ? paginator.data : []
    return {
      data: list,
      total: paginator?.total ?? 0,
      currentPage: paginator?.current_page ?? 1,
      lastPage: paginator?.last_page ?? 1,
      perPage: paginator?.per_page ?? 20,
    }
  },

  approve: async (paymentId: number): Promise<void> => {
    await apiClient.post(`${API_ENDPOINTS.PAYMENTS}/${paymentId}/approve`)
  },

  uploadProof: async (paymentId: number, file: File): Promise<Payment> => {
    const formData = new FormData()
    formData.append('proof_file', file)
    formData.append('_method', 'PATCH')
    const response = await apiClient.post<{ success: boolean; data: Payment }>(
      `${API_ENDPOINTS.PAYMENTS}/${paymentId}`,
      formData,
      { headers: { 'Content-Type': 'multipart/form-data' } }
    )
    return response.data.data
  },
}
